import { IPropertyOwner } from "./propertyOwner";
import { IPropertyOwnerLastTransfer } from "./propertyOwnerLastTransfer";
import { IPropertyOwnerVesting } from "./propertyOwnerVesting";
import { IPropertySite } from "./propertySite";

export interface IPropertyDetailsResponse{
    occupancy: string;
    county: string;
    apn: string;
    delinquentYear: number;
    propertyOwnerNames: string;
    propertyOwnerVesting: IPropertyOwnerVesting;
    propertySite: IPropertySite;
    propertyOwners: IPropertyOwner[];
    propertyOwnerLastTransfer: IPropertyOwnerLastTransfer;
}

export class PropertyDetailsResponse implements IPropertyDetailsResponse {
    public occupancy: string;
    public county: string;
    public apn: string;
    public delinquentYear: number;
    public propertyOwnerNames: string;
    public propertyOwnerVesting: IPropertyOwnerVesting;
    public propertySite: IPropertySite;
    public propertyOwners: IPropertyOwner[];
    public propertyOwnerLastTransfer: IPropertyOwnerLastTransfer;
}